/**
 * The list of locale codes that the site will claim to support. The user
 * will be able to change the site's displayed language using the locales
 * supported in this list.
 * @type { string[] }
 */
export const SUPPORTED_LANGUAGES = [
    // THESE ARE IN THE TRANSLATIONS SPREADSHEET  
    { code: 'en-US', label: 'US-English' },
    { code: 'en-CA', label: 'Canada-English' },
    { code: 'fr-CA', label: 'Canada-French' },
    { code: 'en-ZA', label: 'SouthAfrica-English' },
    { code: 'it-IT', label: 'Italy-Italian' },
    { code: 'en-GB', label: 'UK-English' },
    { code: 'en-IN', label: 'India-English' },
    { code: 'nl-BE', label: 'Belgium-Dutch' },
    { code: 'fr-BE', label: 'Belgium-French' },
    { code: 'de-BE', label: 'Belgium-German' },
    { code: 'fr-FR', label: 'France-French' },
    { code: 'es-ES', label: 'Spain-Spanish' },
    { code: 'fi-FI', label: 'Finland-Finish' },
    { code: 'nl-NL', label: 'Netherlands-Dutch' },
    { code: 'de-DE', label: 'Germany-German' },
    { code: 'tr-TR', label: 'Turkey-Turkish' },
    { code: 'ms-MY', label: 'Malaysia-Malay' },
    { code: 'en-MY', label: 'Malaysia-English' },
    { code: 'en-AU', label: 'Australia-English' },
    { code: 'pl-PL', label: 'Poland-Polish' },
    { code: 'cs-CZ', label: 'Czech-Czech' },
    { code: 'ro-RO', label: 'Romania-Romanian' },
    { code: 'zh-CN', label: 'Simplified-Chinese' },
    { code: 'zh-TW', label: 'Taiwan Chinese' },
    { code: 'ko-KR', label: 'SouthKorea-Korean' },
    { code: 'he-IL', label: 'Hebrew' },
    { code: 'ja-JP', label: 'Japanese' },
    { code: 'sl-SL', label: 'Slovenian' },
    { code: 'ka-GE', label: 'Georgian' },
    { code: 'it-CH', label: 'Switzerland-Italian' },

    // THESE ARE NOT IN THE TRANSLATIONS SPREADSHEET YET  
    { code: 'pt-BR', label: 'Brazil-Portuguese' },
    { code: 'pt-PT', label: 'Portugal-Portuguese' },
    { code: 'hu-HU', label: 'Hungary-Hungarian' },
    { code: 'ru-RU', label: 'Russia-Russian' },
    { code: 'th-TH', label: 'Thailand-Thai' },
    { code: 'zh-HK', label: 'HongKong-Chinese' },
    { code: 'id-ID', label: 'Indonesia-Indonesian' },
    { code: 'ph-PH', label: 'Philippines-Filipino' },
    { code: 'zh-SG', label: 'Singapore-Chinese' },
    { code: 'de-CH', label: 'Switzerland-German' },
    { code: 'de-AT', label: 'Austria-German' },
    { code: 'sv-SE', label: 'Sweden-Swedish' },
    { code: 'da-DK', label: 'Denmark-Danish' },
    { code: 'ko-KR', label: 'SouthKorea-Korean' },
    { code: 'hi-IN', label: 'India-Hindi' }, 
];

/**
 * A mapping of standard locale codes to locale codes supported by Chameleon.
 */
export const LOCALE_CODE_TO_CHAMELEON_LANGUAGE = {
    'zh-HK': 'zh-HK', // Chinese (Hong Kong)
    'zh-TW': 'zh-TW', // Chinese (Taiwan)
    'zh-CN': 'zh', // Chinese Simplified (简体中文)
    'cs-CZ': 'cs', // Czech (Česky)
    'da-DK': 'da', // Danish
    'nl-NL': 'nl', // Dutch
    'nl-BE': 'nl-BE', // Dutch (Belgium)
    'en-AU': 'en-AU', // English (ANZ)
    'en-CA': 'en-CA', // English (Canada)
    'en-IN': 'en-IN', // English (India)
    'en-MY': 'en-MS', // English (Malaysia)
    'en-PH': 'en-PH', // English (Philippines)
    'en-SG': 'en-SG', // English (Singapore)
    'en-ZA': 'en-ZA', // English (South Africa)
    'en-US': 'USA', // English - Code changed to 'USA' for HOYA specifically
    'en-GB': 'gb', // English UK
    'fi-FI': 'fi', // Finnish
    'fr-BE': 'fr-BE', // French (Belgium)
    'fr-CA': 'fr-CA', // French (Français Canadien)
    'fr-FR': 'fr', // French (Français) 
    'fr-MA': 'fr-MA', //French Morocco
    'fr-CH': 'fr-CH', //French Switzerland
    'it-CH': 'it-CH', //Italian Switzerland
    'de-AT': 'de-AT', // German (Austria)
    'de-BE': 'de-BE', // German (Belgium)
    'de-DE': 'de-DE', // German (Deutsch)
    'de-CH': 'gsw', // German (Switzerland)
    'el-GR': 'el', // Greek
    'en-HK': 'en-HK', // English hong kong
    'he-IL': 'he', // Hebrew (עברית)
    'hi-IN': 'hi', // Hindi (हिंदी)
    'hu-HU': 'hu', // Hungarian (Magyar)
    'id-ID': 'id', // Indonesian (Bahasa Indonesia)
    'it-IT': 'it', // Italian (Italiano)
    'ja-JP': 'ja-JP', // Japanese
    'ko-KR': 'ko', // Korean (한국어)
    'lt-LT': 'lt', // Lithuanian
    'ms-MY': 'ms', // Malay (Melayu)
    'nb-NO': 'no', // Norwegian
    'pl-PL': 'pl', // Polish (Język polski)
    'pt-BR': 'pt-BR', // Portuguese Brazil (Português (Brasil))
    'pt-PT': 'pt', // Portuguese Portugal (Português (Portugal))
    'ro-RO': 'ro', // Romanian (Română)
    'ru-RU': 'ru', // Russian (русский)
    'sk-SK': 'sk', //  
    'es-CO': 'es-CO', //Spanish (Columbia) (es-CO)
    'es-ES': 'es', // Spanish (español (de España)(Spain),
    'sv-SE': 'sv', // Swedish
    'th-TH': 'th', // Thai (ภาษาไทย)
    'tr-TR': 'tr', // Turkish (Türkçe)
    'sl-SI': 'sl', // Slovenian
    'kk-KZ': 'kk', // Kazakhstan
    'ka-GE': 'ka-GE', // Georgian,

    'fa-IR': 'fa-IR', // Farsi
    'ar-SA': 'ar-SA', // Arabic
    'bg-BG': 'bg',    // Bulgaria
};

/**
 * The locale code of the default language to attempt to use for displaying
 * the site's content.
 * @type { string }
 */
export const DEFAULT_LOCALE_CODE = 'en-US';

/**
 * Whether or not the site should rely on local translations or if it should
 * attempt to use external translations first.
 * @type { boolean }
 */
export const ONLY_USE_LOCAL_TRANSLATIONS = true;

/**
 * Whether or not the user (regardless of who they are) is allowed to select
 * the language they'd prefer to view the site in.
 * @type { boolean }
 */
export const ALLOW_LANGUAGE_SELECTION = false;

/**
 * local storage key for preferred locale
 */
export const PREFERRED_LOCALE = 'pref_loc';